export default __webpack_public_path__ + "static/ionoview-logo.6d08f56e.svg";